import React, { useEffect, useState } from "react";
import Seo from "../Seo";
import { Helmet } from "react-helmet";
import { Route, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import case_under from "../../images/case_under.png";
import case_picture from "../../images/case-img-main.png";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
const CaseStudyDetails = () => {
  const [searchResults, setSearchResults] = useState({});
  const [departmentId, setDepartmentId] = useState();
  const [loading, setLoading] = useState(false);
  const [scheduleReqData, setScheduleReqData] = useState({
    DoctorID: "",
    PreferredDate: "",
    doctorData: "",
  });
  const route = useParams();
  const images = [
    "/assets/images/blog_1.png",
    "/assets/images/blog_2.png",
    "/assets/images/blog_3.png",
    "/assets/images/blog_4.png",
  ];

  useEffect(() => {
    const getCaseStudies = (data) => {
      try {
        setLoading(true);
        const req = scAxiosAdmin
          .request(`/case_studies/${route.id}`, {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setLoading(false);
              setSearchResults(data.data);
            }
          })
          .catch((e) => {
            setLoading(false);
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getCaseStudies();
  }, []);

  return (
    <div>
      <Seo
        title="Case Study | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Case Study"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
        <section className="banner-hero">
          <img
            src="/assets/images/banner-case-study.png"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section className="container">
          <div className="d-flex flex-column justify-content-between align-items-center px-5 py-4">
            <div className="1">
              <h3
                className="text-left "
                style={{
                  color: "#0C807D",
                  fontSize: "28px",
                  fontWeight: "500",
                  display: "flex",
                  flexDirection: "column",
                  
                }}
              >
                Case Study
                {/* <img
                  src={case_under}
                  style={{ width: "100%", maxWidth: "79px" }}
                  alt=""
                /> */}
              </h3>
            </div>
          </div>
        </section>
        <section class="container pb-4">
          {searchResults ? (
            <div class="row g-0">
              {/* <div class="col-md-5">
                <img src={case_picture} width={546} alt="" />
              </div> */}
              <div
                class="col-md-12 d-flex flex-column justify-content-between"
                style={{ backgroundColor: "#F7F7F7" }}
              >
                <div
                  className="d-flex pt-3 px-3 "
                  style={{ backgroundClip: "#E7F2F2" }}
                >
                  <img src={case_under} alt="" width={3} height={70} />
                  <h3
                    className="px-4 pt-2"
                    style={{
                      fontSize: "22px",
                      textTransform: "capitalize",
                    }}
                  >
                    {searchResults.title}
                  </h3>
                </div>

                <div class="card">
                  <div class="card-body">
                    <li style={{ fontSize: "22px", fontWeight: "bold" }}>
                      {searchResults.doctor_mave
                        ? searchResults.doctor_mave.doctor_name
                        : ""}
                    </li>
                    <p class="card-text">
                      {searchResults.doctor_mave
                        ? searchResults.doctor_mave.degree
                        : ""}
                    </p>
                    <div
                      className=""
                      dangerouslySetInnerHTML={{
                        __html: searchResults.description,
                      }}
                    ></div>

                    <div className="row d-flex justify-content-between align-items-center pt-5 px-2">
                      {searchResults.gallery
                        ? searchResults.gallery.map((image, index) => (
                            <div
                              className="col-md-3 imgContainer p-0"
                              style={{
                                maxHeight: "300px",
                                maxWidth: "300px",
                              }}
                            >
                              <img
                                style={{
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                }}
                                src={`${IMAGE_URL}${image}`}
                                alt=""
                              />
                            </div>
                          ))
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </section>
        {/* <section className="container">
          <div className="d-flex flex-column justify-content-md-center align-items-center p-5">
            <div className="d-flex"></div>
            <div className="d-flex"></div>
          </div>
        </section> */}
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default CaseStudyDetails;



// WEBPACK FOOTER //
// ./src/component/frontend/CaseStudyDetails.js